export default {"src":"/_next/static/media/WarningLight.90b909d8.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};